import { DataLayer } from '@by-miles/data-layer'
import Lottie from 'lottie-react'

import { PlayAgainButton, PlayNextButton } from '../components/buttons'
import { ExplainerStep } from '../components/ExplainerStep'
import { ExplainerProps } from '../types'
import { AnimationSteps } from '../types'
import animationData from './assets/explainer-bmmb-how-clips.json'

export const MoneyBackExplainer = ({
  lottieRef,
  activeStep,
  handlePlayStep,
  animationProgress,
  annimationTriggerRef,
}: ExplainerProps) => {
  const handlePlayNext = (step: AnimationSteps) => {
    DataLayer.customEvent({
      eventName: 'bmmb animation play next',
      eventType: 'form tracking',
      section: 'how',
    })
    handlePlayStep(step)
  }

  return (
    <>
      <div className="section">
        <Lottie lottieRef={lottieRef} animationData={animationData} autoplay={false} loop={false} />
      </div>
      <div className="section">
        <div className="step-wrapper">
          <ExplainerStep
            step={1}
            title="Estimate your miles and make a single upfront payment. Piece of cake."
            text="A slice of that goes towards covering your car while it’s parked."
            button={<PlayNextButton onClick={() => handlePlayNext(AnimationSteps.Two)} />}
            activeStep={activeStep}
            progress={animationProgress}
          />
          <ExplainerStep
            step={2}
            title="The rest covers the miles you drive, from the short trips, to the longer ones."
            text="If you need more miles, you can simply top up at any time."
            button={<PlayNextButton onClick={() => handlePlayNext(AnimationSteps.Three)} />}
            activeStep={activeStep}
            progress={animationProgress}
          />
          <div ref={annimationTriggerRef} />
          <ExplainerStep
            step={3}
            title="But when you’re not driving, you’re not spending any of the miles you paid for at the start of the year."
            text="At the end of the year, we’ll refund any miles you have left back to you."
            button={
              <PlayAgainButton
                onClick={() => {
                  DataLayer.customEvent({
                    eventName: 'bmmb animation play again',
                    eventType: 'form tracking',
                    section: 'how',
                  })
                  handlePlayStep(AnimationSteps.One)
                }}
              />
            }
            activeStep={activeStep}
            progress={animationProgress}
          />
        </div>
      </div>
    </>
  )
}
